export const SCHOOL_YEARS = [
  { id: 'EI', text: 'Educação Infantil' },
  { id: '1', text: '1º ano' },
  { id: '2', text: '2º ano' },
  { id: '3', text: '3º ano' },
  { id: '4', text: '4º ano' },
  { id: '5', text: '5º ano' },
  { id: '6', text: '6º ano' },
  { id: '7', text: '7º ano' },
  { id: '8', text: '8º ano' },
  { id: '9', text: '9º ano' },
  { id: 'M', text: 'Ensino Médio' }
]
